import React from 'react';
import useActionableAnnotation from 'src/components/ActionableTooltip/useActionableAnnotation';
import WarningAmberRounded from '@mui/icons-material/WarningAmberRounded';
import { Box, Tooltip, Stack } from '@mui/material';

/** Annotation stays out of table sizing and never replaces the cell value. */
export default function TableValidationFlag({ message, severity = 'error', inline = false, action, openOnMount = false, triggerRef }: {
  message: string; severity?: 'error' | 'warning'; inline?: boolean; action?: React.ReactNode;
  openOnMount?: boolean; triggerRef?: React.RefObject<HTMLElement>;
}) {
  const actionable = !!action;
  const { anchor: flag, content: annotation, open, preview, hidePreview, pin, close } = useActionableAnnotation<HTMLButtonElement>({
    enabled: actionable, openOnMount, contentKey: message, triggerRef
  });

  return <Tooltip open={open} onOpen={preview} onClose={hidePreview}
    title={action ? <Stack ref={annotation} spacing={1} onClick={event => {
      event.stopPropagation();
      if ((event.target as Element).closest('button, a, [role="menuitem"], [role="option"]')) close();
    }}>{message}{action}</Stack> : message} arrow describeChild>
    <Box component="button" type="button"
      ref={flag}
      aria-label={`Review: ${message}`}
      aria-expanded={actionable ? open : undefined}
      onClick={event => { event.stopPropagation(); if (actionable) pin(); }}
      sx={{ position: inline ? 'relative' : 'absolute', flexShrink: 0, right: 1, top: 1, p: 0, width: 14, height: 14,
        border: 0, borderRadius: severity === 'warning' ? 0 : '50%', bgcolor: severity === 'warning' ? 'transparent' : '#8f1d1d', color: severity === 'warning' ? 'warning.dark' : '#fff',
        fontSize: 10, lineHeight: '14px', cursor: 'help', zIndex: 1,
        '&:focus-visible': { outline: '2px solid #1565c0', outlineOffset: 1 } }}>{severity === 'warning' ? <WarningAmberRounded sx={{ width: '100%', height: '100%' }} /> : '!'}</Box>
  </Tooltip>;
}
